<template>
  <div>
    <Form ref="form" :model="form" :label-width="90" :rules="rules">
      <FormItem label="部队名称：" prop="purchase">
        <Input v-model="purchaseData.purchase" style="width:80%" readonly></Input>
      </FormItem>
      <FormItem label="部队番号：" prop="designation">
        <Input v-model="form.designation" style="width:80%"></Input>
      </FormItem>
      <FormItem label="内部编号：" prop="internalNumber">
        <Input v-model="form.internalNumber" style="width:80%"></Input>
      </FormItem>
      <FormItem label="部队属性：" prop="internalNumber">
        <Select v-model="form.unitAttribute" style="width:160px;display:inline-block">
        <Option
          v-for="item in propertyArr"
          :value="item.itemName"
            :key="item.key"
        >{{ item.itemName }}</Option>
      </Select>
      </FormItem>
      <FormItem label="资金来源：" prop="source">
        <Select v-model="form.source" style="width:160px;display:inline-block">
        <Option
          v-for="item in fundsprovidArr"
          :value="item.itemName"
            :key="item.key"
        >{{ item.itemName }}</Option>
      </Select>
      </FormItem>
      <FormItem label="上级单位：" prop="superiorDepartment">
        <Input v-model="form.superiorDepartment" style="width:80%"></Input>
      </FormItem>
      <FormItem label="部队战区：" prop="area">
        <Input v-model="form.area" style="width:80%"></Input>
      </FormItem>
      <FormItem label="附加信息：" prop="extraMessage">
        <Input v-model="form.extraMessage" style="width:80%"></Input>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import ajax from '@/lib/ajax'

export default {
  props: ["purchaseData", 'show'],
  data() {
    return {
      form: {
        purchaseID: '',
        designation: '',
        internalNumber: '',
        unitAttribute: '',
        source: '',
        area: '',
        extraMessage: '',
        superiorDepartment: ''
      },
      rules: {
        designation: [
          { required: true, trigger: 'blur', message: '部队番号不能为空' }
        ],
        internalNumber: [
          { required: true, trigger: 'blur', message: '内部编号不能为空' }
        ],
        unitAttribute: [
          { required: true, trigger: 'blur', message: '部队属性不能为空' }
        ],
        source: [
          { required: true, trigger: 'blur', message: '资金来源不能为空' }
        ],
        area: [
          { required: true, trigger: 'blur', message: '部队战区不能为空' }
        ],
        extraMessage: [
          { required: true, trigger: 'blur', message: '附加信息不能为空' }
        ],
        superiorDepartment: [
          { required: true, trigger: 'blur', message: '上级单位不能为空' }
        ]
      },
      propertyArr: [],
      fundsprovidArr: []
    }
  },
  // 得到分公司列表
  async created() {
    let rep1 = await ajax.get('/api/services/app/AbpDataDict/GetListByType', {
      params: {
        type: '资金类型(军工)'  
      }
    })
    this.fundsprovidArr = rep1.data.result.items
    let rep2 = await ajax.get('/api/services/app/AbpDataDict/GetListByType', {
      params: {
        type: '军种'  
      }
    })
    this.propertyArr = rep2.data.result.items
  },
  watch: {
    show (val) {
      if (val) {
        this.form = {
          purchaseID: '',
          designation: '',
          internalNumber: '',
          unitAttribute: '',
          source: '',
          area: '',
          extraMessage: '',
          superiorDepartment: ''
        }
        this.$Spin.show()
        ajax.get('http://192.168.169.50:52019/api/services/app/ClJGPurchase/GetPaged', {
          params: {
            filter: `purchaseID == ${this.purchaseData.id}`
          }
        }).then(res => {
          this.$Spin.hide()
          if (res.data.result.totalCount) {
            this.form = res.data.result.items[0]
          } else {
            this.form.purchaseID = this.purchaseData.id
          }
        })
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.session.user
    },
    permission () {
      let permission = this.$store.getters["session/hasRoles"]("分公司负责人") || this.$store.getters["session/hasRoles"]("档案管理员")
      return permission
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$Spin.show()
          ajax.post('http://192.168.169.50:52019/api/services/app/ClJGPurchase/CreateOrUpdate', {
            clJGPurchase: this.form
          }).then(res => {
            this.$Spin.hide()
            this.$Message.success('修改成功!')
            this.$emit('close')
          })
        } else {
          this.$Message.error('请完善信息填写!')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.info-item {
  min-width: 150px;
  margin: 0 0 10px 20px;
  display: inline-block;
}
.info-item-span {
  display: inline-block;
  vertical-align: top;
  margin-top: 5px;
}
.oInp {
  color: red;
  width: 150px;
}
.bInp {
  margin-right: 30px;
}
.icon {
  vertical-align: middle;
}
// 包裹联系人与反思的Box
.ptBox {
  display: inline-block;
}
.ptBox div {
  margin-bottom: 5px;
}
li {
  list-style-type: none;
}
</style>